import React from 'react';
import { AiOutlineEdit } from '@react-icons/all-files/ai/AiOutlineEdit';

export default function EditBtn() {
    return (
        <AiOutlineEdit className="green-btn-plus"/>
    )
}